import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const useResponsive = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const isExceedsHulp = useMediaQuery("(max-width:1150px)");

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLandscape,
    isExceedsHulp,
  };
};

// export default useResponsive;
// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useState, useEffect } from "react";

// const useResponsive = () => {
//   const theme = useTheme();

//   const [isClient, setIsClient] = useState(false);

//   useEffect(() => {
//     setIsClient(true);
//   }, []);

//   const isMobileQuery = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTabletQuery = useMediaQuery(theme.breakpoints.between("sm", "lg"));
//   const isDesktopQuery = useMediaQuery(theme.breakpoints.up("lg"));

//   const isLandscape = useMediaQuery("(orientation: landscape)");

//   const getDeviceType = () => {
//     if (!isClient) return {};

//     const ua = navigator.userAgent;
//     const width = window.innerWidth;
//     const height = window.innerHeight;

//     const isIPad =
//       /iPad/.test(ua) || (/Macintosh/.test(ua) && "ontouchend" in document);
//     const isTablet = /Tablet|iPad/.test(ua) || (width >= 768 && width <= 1024);
//     const isMobile = /iPhone|Android/.test(ua) || width < 768;

//     return {
//       isMobile: isMobile && !isTablet && !isIPad,
//       isTablet: isTablet && !isIPad,
//       isIPad,
//       isDesktop: !isMobile && !isTablet && !isIPad,
//     };
//   };

export default useResponsive;
